import { Button, Box, ButtonProps } from "@xcorejs/ui";
import { useRouter } from "next/router";
import { Dispatch, SetStateAction } from "react";
import RssIcon from "components/Icons/24/rss.svg";
import { useLayout } from "../../xcore/index";

type RssButtonProps = {
  isRssCopied: boolean;
  setIsRssCopied: Dispatch<SetStateAction<boolean>>;
} & ButtonProps;

export const RssButton = ({ isRssCopied, setIsRssCopied, ...props }: RssButtonProps) => {
  const { locale } = useRouter();
  const { general, stringify } = useLayout();

  return (
    <Button
      size="xs"
      variant="clear"
      borderRadius={0}
      padding="5px !important"
      as="a"
      display="flex"
      alignItems="center"
      href={`/api/robe/rss/${locale ?? "en"}`}
      target="_blank"
      whiteSpace="pre"
      onClick={(e) => {
        e.preventDefault();
        navigator.clipboard.writeText(`${window.location.protocol}//${window.location.host}/api/robe/rss/${locale ?? "en"}`).then(() => {
          setIsRssCopied(true);
        });
      }}
      {...props}
    >
      <Box mr=".4rem" width="24px" height="24px">
        <RssIcon />
      </Box>{" "}
      {!isRssCopied ? "RSS" : stringify(general.values.rssCopied)}
    </Button>
  );
};
